module.exports = __webpack_public_path__ + "img/taoyuan-3.60a7fcf3.jpg";